import React from "react";
import classNames from "classnames";

const starIcons = {
  0: "star_border",
  1: "star_half",
  2: "star",
};

export default class StarControl extends React.PureComponent {
  triggerChange(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onChange } = this.props;
    const nextValue = (this.props.value + 1) % 3;
    onChange && onChange(nextValue);
  }

  render() {
    const { onChange, readOnly, disabled, alternative = false, ...rest } = this.props;
    const value = this.props.value || 0;
    return (
      <div
        className={classNames({
          "c-StarControl": true,
          [`c-StarControl--value-${value}`]: true,
          "c-StarControl--alternative": alternative,
          disabled,
          readOnly,
        })}
        onClick={this.triggerChange.bind(this)}
      >
        <i className="icon material-icons">{starIcons[value]}</i>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Star.jsx